export const isNotificationRequired = ({
  isVerificationRequired,
  isNeedSetupLimits,
  isPassportVerifiedByRisk,
  isAdditionalInformationRequired,
  isPassportInVerification
}) => {
  if (!isNeedSetupLimits) {
    return false;
  }
  if (isVerificationRequired) {
    return (
      isPassportVerifiedByRisk ||
      isAdditionalInformationRequired ||
      isPassportInVerification
    );
  }

  return true;
};
